/**
 * Site-wide wishlist (localStorage). Used by PDP, header, and wishlist page.
 */
(function (global) {
  'use strict';

  var KEY = 'gomila-wishlist';

  function normalizeEntry(entry) {
    if (!entry) return null;
    if (typeof entry === 'string' || typeof entry === 'number') {
      return { id: String(entry), handle: '', title: '', url: '', image: '', price: '' };
    }
    return {
      id: String(entry.id || ''),
      handle: entry.handle || '',
      title: entry.title || '',
      url: entry.url || '',
      image: entry.image || '',
      price: entry.price || ''
    };
  }

  function getAll() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(raw)) return [];
      return raw.map(normalizeEntry).filter(function (e) {
        return e && e.id;
      });
    } catch (e) {
      return [];
    }
  }

  function save(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
    document.documentElement.dispatchEvent(
      new CustomEvent('wishlist:change', { bubbles: true, detail: { items: items } })
    );
    updateHeaderCount();
  }

  function has(id) {
    var sid = String(id);
    return getAll().some(function (item) {
      return item.id === sid;
    });
  }

  function add(product) {
    var items = getAll();
    var entry = normalizeEntry(product);
    if (!entry.id) return items;
    var idx = items.findIndex(function (i) {
      return i.id === entry.id;
    });
    if (idx === -1) {
      items.push(entry);
      save(items);
    }
    return items;
  }

  function remove(id) {
    var sid = String(id);
    var items = getAll().filter(function (i) {
      return i.id !== sid;
    });
    save(items);
    return items;
  }

  function toggle(product) {
    if (has(product.id)) {
      remove(product.id);
      return false;
    }
    add(product);
    return true;
  }

  function updateHeaderCount() {
    var count = getAll().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('opacity-0', count === 0);
      el.setAttribute('aria-hidden', count === 0 ? 'true' : 'false');
    });
  }

  global.GomilaWishlist = {
    KEY: KEY,
    getAll: getAll,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    updateHeaderCount: updateHeaderCount
  };

  document.addEventListener('DOMContentLoaded', updateHeaderCount);
  document.addEventListener('wishlist:change', updateHeaderCount);
})(window);
